import React from 'react';
import './LoadingWidget.css';

interface LoadingWidgetProps {
  message?: string;
}

const LoadingWidget: React.FC<LoadingWidgetProps> = ({ message = "Loading..." }) => {
  return (
    <div className="loading-widget">
      <div className="loading-widget-container">
        <div className="loading-spinner"></div>
        <p className="loading-message">{message}</p>
      </div>
    </div>
  );
};

export default LoadingWidget;
